<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="page-title mb-3">
            <h3 class="text-center">Compose SMS</h3>
          </div>
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="submitForm">
                <div class="border-bottom mb-3">
                  <div class="row">
                    <!-- Campaign Name -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Campaign Name <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="campaignName"
                        />
                      </div>
                    </div>

                    <!-- Sender ID -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Sender ID</label>
                        <select class="form-control" v-model="senderId">
                          <option value="">Select Sender ID</option>
                          <option value="SavorExpo">SavorExpo</option>
                          <option value="Sender2">Sender ID 2</option>
                        </select>
                      </div>
                    </div>

                    <!-- Contacts -->
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">Contacts</label>
                        <textarea
                          class="form-control"
                          rows="3"
                          v-model="contacts"
                        ></textarea>
                        <div class="form-check mt-2">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="autoAddCountryCode"
                          />
                          <label class="form-check-label"
                            >Auto Add Country Code (880)</label
                          >
                        </div>
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="removeDuplicate"
                          />
                          <label class="form-check-label"
                            >Remove Duplicate</label
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Data Coding -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Data Coding</label>
                        <select class="form-control" v-model="dataCoding">
                          <option value="default">Default (GSM)</option>
                          <option value="unicode">Unicode</option>
                        </select>
                      </div>
                    </div>

                    <!-- Enter Message -->
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">Enter Message</label>
                        <div class="input-group">
                          <textarea
                            class="form-control"
                            rows="4"
                            v-model="message"
                          ></textarea>
                          <span class="input-group-text">
                            <i class="fas fa-clipboard"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- SMS Count -->
                    <div class="col-md-12">
                      <p>Used: | Left: 1224 | SMS Count: 0</p>
                    </div>

                    <!-- Schedule Checkbox -->
                    <div class="col-md-12">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="schedule"
                        />
                        <label class="form-check-label">Schedule</label>
                      </div>
                    </div>

                    <!-- Buttons -->
                    <div class="col-md-12 text-end mt-3">
                      <button type="button" class="btn btn-secondary me-2">
                        Save As Draft
                      </button>
                      <button type="submit" class="btn btn-primary">
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      campaignName: "",
      senderId: "",
      contacts: "",
      autoAddCountryCode: false,
      removeDuplicate: false,
      dataCoding: "default",
      message: "",
      schedule: false,
    };
  },
  methods: {
    submitForm() {
      console.log("Sending SMS Campaign:", this.$data);
    },
  },
};
</script>

<style scoped>
.btn {
  min-width: 120px;
}
</style>
